export default "__VITE_ASSET__Duyyw36G__"